// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"hamburger"},"nodeName":"g","children":[{"attributes":{"id":"fill1"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M4 10C4 5.58172 7.58173 3 12 3C16.4183 3 20 5.58172 20 10H4Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M4 18H20C20 20.2091 18.2091 22 16 22H8C5.79086 22 4 20.2091 4 18Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke1"},"nodeName":"g","children":[{"attributes":{"stroke":"currentColor","d":"M4 10C4 5.58172 7.58173 3 12 3C16.4183 3 20 5.58172 20 10H4Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"stroke":"currentColor","d":"M4 18H20C20 20.2091 18.2091 22 16 22H8C5.79086 22 4 20.2091 4 18Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M3 15L6 13L9 15L12 13L15 15L18 13L21 15","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-hamburger')
export default class HamburgerIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'hamburger',
    }
  }
}
